import { useEventCompanyRole } from "@/lib/query/hooks/useEventEntitlements";

/**
 * May this caller export a guest of `eventId` (Art. 15)? The server's own
 * rule — main-backend `EventTenantGuard.requireCallerRoleInEventCompany` with
 * `COMPANY_WRITE_ROLES`: a company role OWNER / ADMIN / EDITOR in the EVENT's
 * company, read off the event's entitlements (`viewer.companyRole`), so it
 * holds whichever company the login is switched to. A CUSTOM role, an event
 * role alone and a role preview carry no such company role there.
 *
 * FAIL-CLOSED: loading, a failed read and no event ⇒ `false`. The server stays
 * the lock; this only keeps a button away that would be refused.
 */
export function useGuestDataExportAllowed(eventId: string | null | undefined): boolean {
  const { canWriteCompanyAssets } = useEventCompanyRole(eventId || null);
  return !!eventId && canWriteCompanyAssets;
}
